const appConfig = Object.freeze({
  apiUrl: process.env.REACT_APP_API_URL,
  clientUrl: process.env.REACT_APP_CLIENT_URL,
  cacheUrl: process.env.REACT_APP_FUNC_URL
});

export default appConfig;
